import React from 'react';

const FormSection = ({ title, children, className = '', fullWidth = false }) => {
  return (
    <div className={`w-full ${fullWidth ? 'md:w-full' : 'md:w-[calc(50%-12px)]'} space-y-4 bg-gray-50 p-6 rounded-lg ${className}`}>
      <div>
        <h3 className="text-lg font-medium leading-6 text-gray-900 border-b pb-2">{title}</h3>
      </div>
      {children}
    </div>
  );
};

export default FormSection;
